import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { setCookie } from '@miro-site/core';
import React, { useEffect, useState } from 'react';
import { DEFAULT_LOCALE, LOCALE_COOKIE, LOCALE_LABELS, RTL_LANGUAGES } from '../constants';
import toBaseLocale from '../utils/toBaseLocale';
import { detectLocale as detectLocaleUtility } from '../utils/detectLocale';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultLocalizationData = {
  defaultLocale: DEFAULT_LOCALE,
  currentLocale: DEFAULT_LOCALE,
  isRTL: RTL_LANGUAGES.includes(DEFAULT_LOCALE),
  localeLabels: LOCALE_LABELS,
  onChangeLocale: function onChangeLocale(locale) {
    return setCookie(LOCALE_COOKIE, locale, 0);
  },
  translations: []
};
export var LocaleContext = /*#__PURE__*/React.createContext(defaultLocalizationData);

var LocalizationProvider = function LocalizationProvider(props) {
  var children = props.children,
      _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      _props$detectLocale = props.detectLocale,
      detectLocale = _props$detectLocale === void 0 ? true : _props$detectLocale,
      _props$detectTranslat = props.detectTranslations,
      detectTranslations = _props$detectTranslat === void 0 ? true : _props$detectTranslat,
      _props$changeLocaleOn = props.changeLocaleOnLoad,
      changeLocaleOnLoad = _props$changeLocaleOn === void 0 ? true : _props$changeLocaleOn,
      _props$useBaseLocale = props.useBaseLocale,
      useBaseLocale = _props$useBaseLocale === void 0 ? true : _props$useBaseLocale;

  var _useState = useState({
    currentLocale: DEFAULT_LOCALE,
    translations: []
  }),
      detectedLocalizationData = _useState[0],
      setDetectedLocalizationData = _useState[1];

  var mergedData = _objectSpread(_objectSpread(_objectSpread({}, defaultLocalizationData), detectedLocalizationData), data);

  var normalizeLocale = function normalizeLocale(locale) {
    return useBaseLocale ? toBaseLocale(locale) : locale;
  };

  var defaultLocale = normalizeLocale(mergedData.defaultLocale);
  var currentLocale = normalizeLocale(mergedData.currentLocale);
  var translations = (mergedData.translations || []).map(function (t) {
    return _objectSpread(_objectSpread({}, t), {}, {
      locale: normalizeLocale(t.locale)
    });
  });
  useEffect(function () {
    var detectedLocale = defaultLocale;

    if (detectLocale) {
      var _detectLocaleUtility;

      detectedLocale = (_detectLocaleUtility = detectLocaleUtility(document.location.pathname)) !== null && _detectLocaleUtility !== void 0 ? _detectLocaleUtility : detectedLocale;
    }

    var detectedTranslations = [];

    if (detectTranslations) {
      detectedTranslations = Object.keys(window.mrTranslations || {}).reduce(function (acc, locale) {
        var a = document.createElement('a');
        a.href = window.mrTranslations[locale];
        acc.push({
          locale: locale,
          url: a.pathname || '/'
        });
        return acc;
      }, []);
    }

    if (detectLocale || detectTranslations) {
      setDetectedLocalizationData({
        currentLocale: detectedLocale,
        translations: detectedTranslations
      });
    }
  }, [detectLocale, detectTranslations]);
  useEffect(function () {
    if (changeLocaleOnLoad && currentLocale !== defaultLocale) {
      mergedData.onChangeLocale(currentLocale);
    }
  }, [changeLocaleOnLoad]);
  return /*#__PURE__*/_jsx(LocaleContext.Provider, {
    value: _objectSpread(_objectSpread({}, mergedData), {}, {
      defaultLocale: defaultLocale,
      currentLocale: currentLocale,
      isRTL: RTL_LANGUAGES.includes(currentLocale),
      translations: translations
    }),
    children: children
  });
};

export default LocalizationProvider;